import debounce from "lodash.debounce";
import { api } from "jiffy-api";
import { generateTimeRemainingText } from "common/utils/ui/generate-time-remaining";
import "./jiffymade-landing-delivery.scss";

const DEFAULT_COMPOSITION_ID = "9286";

const $getCutOff = () => document.querySelector(".js-delivery-cut-off");
const $getCutoffPlaceholder = () => document.querySelector(".js-delivery-cut-off-placeholder");
const $getDeliveryDate = () => document.querySelector(".js-delivery-date");
const $getInput = () => document.querySelector(".js-zipcode-input");

let timersTimeouts = [];
const clearTimers = () => {
  timersTimeouts.forEach(timer => clearTimeout(timer));
  timersTimeouts = [];
};

const makeTimer = ($cutoffNode, cutoff) => {
  const $cutoff = $cutoffNode;

  const updateTimer = () => {
    const curTime = Date.now();
    const diff = Math.floor((cutoff - curTime) / 1000);

    $cutoff.innerHTML = generateTimeRemainingText(cutoff, true);
    $cutoff.dataset.timeLeftInMinutes = Math.floor(diff / 60);
    timersTimeouts.push(setTimeout(updateTimer, 60_000)); // One time per minute
  };

  updateTimer();
};

const changeLoadingState = isLoading => {
  if (isLoading) {
    $getInput().classList.remove("error");
    $getDeliveryDate().textContent = "Loading...";
    clearTimers();
  }
};

const refreshDeliveryDate = async (zipcode, initial = false) => {
  changeLoadingState(true);

  try {
    if (!initial) {
      const { error } = await api.location.update({
        zipcode
      });

      if (error) {
        throw error;
      }
    }

    const {
      composition_dates: compositionDates,
      error,
      success
    } = await api.print.estimatedDelivery({
      composition_id: DEFAULT_COMPOSITION_ID
    });

    if (!success) {
      throw new Error(error);
    }

    const cutoffSource = compositionDates.timeleft;
    const cutoffTime = new Date(cutoffSource).getTime();
    makeTimer($getCutoffPlaceholder(), cutoffTime);

    $getCutOff().classList.remove("hidden");
    $getDeliveryDate().textContent = compositionDates.value_full;
  } catch (error) {
    $getCutOff().classList.add("hidden");
    $getDeliveryDate().textContent = "Invalid zipcode";
    $getInput().classList.add("error");
  } finally {
    changeLoadingState(false);
  }
};

const loadZipcode = debounce(zipcode => {
  refreshDeliveryDate(zipcode);
}, 700);

export const initDelivery = () => {
  const $input = $getInput();
  refreshDeliveryDate($input.value, true);

  $input.addEventListener("input", e => {
    const zipcode = e.target.value;
    if (zipcode?.length === 5) {
      loadZipcode(zipcode);
    }
  });
};

export default initDelivery;
